import { Component } from 'react'
import { connect } from 'react-redux'
import ContentMailer from 'components/ContentMailer'
import { TrackingHOC } from 'hocs'
import {
  selectMailerFetching,
  selectMailerSuccess,
  selectMailerError
} from './selectors'
import { sendEmail } from './actions'
import { OptionsHOC } from '../../hocs'

class ContentMailerContainer extends Component {
  state = {
    showModal: false,
    email: '',
    error: '',
    disabled: false,
    name: ''
  }

  emailBody = ''

  componentDidMount() {
    this.emailBody = this.stripPrivateTags(this.props.emailBody)

    if (this.emailBody.trim() === '') {
      this.setState({ disabled: true })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.success && nextProps.isFetching === false) {
      this.closeModal()
      this.setState({ email: '' })
    }

    if (nextProps.error && nextProps.isFetching === false) {
      this.setState({ error: nextProps.error })
    }
  }

  stripPrivateTags = (html) =>
    html.replace(/<private_article[\s\S]+?<\/private_article>/gi, '')

  closeModal = () => {
    this.setState({ showModal: false })
  }

  openModal = (e) => {
    e.preventDefault()
    this.setState({ showModal: true, error: '' })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { sendEmail, createEvent, contentType, contentId, careAssistEmail } =
      this.props
    const { name, email } = this.state
    const lineBreak = "<div style='height:10px; width: 300px;'></div>"

    if (email.trim() !== '') {
      const body = careAssistEmail
        ? careAssistEmail.replace('{name}', name || '') +
          lineBreak +
          this.emailBody
        : this.emailBody

      sendEmail(email, body)
      createEvent({
        category: contentType,
        data: { action: 'ShareByEmail', target: contentId, recipient: email }
      })
    }
  }

  handleChange = (e) => {
    this.setState({ email: e.target.value })
  }

  nameInputValue = (n) => {
    this.setState({ name: n.target.value })
  }

  generateProps = () => ({
    ...this.props,
    ...this.state,
    handleSubmit: this.handleSubmit,
    handleChange: this.handleChange,
    nameInputValue: this.nameInputValue,
    openModal: this.openModal,
    closeModal: this.closeModal
  })

  render() {
    if (this.props.emailDisabled) {
      return false
    }

    return <ContentMailer {...this.generateProps()} />
  }
}

const mapStateToProps = (state, props) => ({
  isFetching: selectMailerFetching(state),
  success: selectMailerSuccess(state),
  error: selectMailerError(state),
  careAssistEmail: props.getOption('CareAssistEmail'),
  emailDisabled: props.getOption('emailDisabled')
})

const mapDispatchToProps = (dispatch) => ({
  sendEmail: (email, body) => dispatch(sendEmail.request(email, body))
})

export default OptionsHOC(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TrackingHOC(ContentMailerContainer))
)
